// 图片上传TSP
import axios from "axios";
import { Notification } from "element-ui";
import Queue from "promise-queue-plus";
import { md5 } from "./lib/md5";
import { taskInfo, initTask, merge, preSignUrl } from "./lib/api";

const getTaskInfo = async (file, options) => {
  let task;
  let identifier = (await md5(file)) + "";
  identifier = identifier.replace(/\//g, "");
  const { status, data, msg } = (await taskInfo(identifier)).data;
  if (status === 200) {
    task = data;
    if (!task) {
      const initTaskData = {
        identifier,
        fileName: file.name,
        totalSize: file.size,
        chunkSize: 5 * 1024 * 1024,
      };
      const { status, data, msg } = (await initTask(initTaskData, options)).data;
      if (status === 200) {
        task = data;
      }
    }
  } else {
    Notification.error({
      title: "文件上传错误",
      message: msg,
    });
  }
  return task;
};

/**
 * 上传逻辑处理，如果文件已经上传完成（完成分块合并操作），则不会进入到此方法中
 */
const handleUpload = (file, taskRecord) => {
  const { exitPartList, chunkSize, chunkNum, fileIdentifier } = taskRecord;

  const uploadNext = async (partNumber) => {
    const start = (new Number(chunkSize)) * (partNumber - 1);
    const end = start + (new Number(chunkSize));
    const blob = file.slice(start, end);
    const { status, data } = (
      await preSignUrl({
        identifier: fileIdentifier,
        partNumber: partNumber,
      })
    ).data;
    if (status === 200 && data) {
      await axios.request({
        url: data,
        method: "PUT",
        data: blob,
        headers: { "Content-Type": "application/octet-stream" },
      });
      return Promise.resolve({
        partNumber: partNumber,
        uploadedSize: blob.size,
      });
    }
    return Promise.reject(`分片${partNumber}， 获取上传地址失败`);
  };

  return new Promise(async (resolve) => {
    const failArr = [];
    const queue = Queue(5, {
      retry: 3, //Number of retries
      retryIsJump: false, //retry now?
      workReject: function (reason) {
        failArr.push(reason);
      },
      queueEnd: function () {
        resolve(failArr);
      },
    });
    for (let partNumber = 1; partNumber <= chunkNum; partNumber++) {
      const exitPart = (exitPartList || []).find((exitPart) => exitPart.partNumber == partNumber);
      if (!exitPart) {
        queue.push(() => uploadNext(partNumber));
      }
    }
    if (queue.getLength() == 0) {
      // 所有分片都上传完，但未合并，直接return出去，进行合并操作
      resolve(failArr);
      return;
    }
    queue.start();
  });
};

// 定义一个函数，接受一个url参数，返回一个数组
function splitUrl(url) {
  // 使用split方法按照/符号分割url
  const arr = url.split("/");
  // 返回一个包含三个元素的数组，第一个元素是协议和域名，第二个元素是桶名，第三个元素是文件路径
  return [arr[0] + "//" + arr[2], arr[3], arr.slice(4).join("/")];
}

export const uploadFile = async (file, options = {}) => {
  const task = await getTaskInfo(file, options);
  if (task) {
    const { finished, path, taskRecord } = task;

    const urls = splitUrl(path);
    const paths = `https://gateway.juxue.cloud/resmanage/resourcesManage/download?bucketName=${urls[1]}&fileName=${urls[2]}`;

    const { fileIdentifier: identifier } = taskRecord;
    if (finished) {
      return paths;
    } else {
      const errorList = await handleUpload(file, taskRecord);
      if (errorList.length > 0) {
        Notification.error({
          title: "文件上传错误",
          message: "部分分片上次失败，请尝试重新上传文件",
        });
        return;
      }
      const { status, msg } = await merge(identifier);
      if (status === 200) {
        return paths;
      } else {
        Notification.error({
          title: "文件上传错误",
          message: msg,
        });
      }
    }
  } else {
    Notification.error({
      title: "文件上传错误",
      message: "获取上传任务失败",
    });
  }
};